<header class="header header--fixed">
  <div class="container-fluid">
    <div class="header__content">
      <nav class="navbar bg-body-dark navbar-expand-xl">
        <div class="d-flex align-items-center">
          <a class="navbar-brand header__logo" href="/">
            <img [src]="
                theme == 'dark'
                  ? 'assets/images/new-logo.svg'
                  : 'assets/images/new-logo.svg'
              " alt="Logo" class="img-fluid" />
          </a>
          <ul class="navbar-nav mobile_none home_navbar_middle">
            <li class="nav-item">
              <a class="nav-link" routerLink="/market-home" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Market</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/fee-home" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Fee</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/spot" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Spot</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" routerLink="/eoptions-trade" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Options</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" routerLink="/launchpad" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Launchpad</a>
            </li>
            <!-- <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dcabot"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                >DCA</a
              >
            </li> -->
            <li class="nav-item" (mouseenter)="showDropdown()" (mouseleave)="hideDropdown()">
              <a class="nav-link" routerLinkActive="active">Earn</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/blog" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Blog</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/subscriptionpage" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Subscription</a>
            </li>
            <!-- <li class="nav-item">
              <a
                class="nav-link"
                [href]="siteSetting.externalSiteUrl"
                target="_blank"
                >{{ siteSetting.externalSiteName }}</a
              >
            </li> -->
            <li class="nav-item" *ngIf="loggedIn">
              <a class="nav-link" routerLink="/dashboard" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Dashboard</a>
            </li>
            <li class="nav-item mx-auto" *ngIf="loggedIn">
              <button class="btn startButton" data-bs-toggle="modal" data-bs-target="#new_bot_modal">
                <img [src]="
                    theme == 'dark'
                      ? 'assets/images/startboticon.svg'
                      : 'assets/images/startboticon.svg'
                  " alt="Bot Status" class="img-fluid" />
                Start New Bot
              </button>
            </li>
          </ul>
        </div>
        <button class="header__btn navbar-toggler" type="button">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <app-theme class="dashboard_theme"></app-theme>
        <div class="home_menu_bar" tabindex="-1">
          <ul class="navbar-nav justify-content-end flex-grow-1 desktop_none">
            <li class="nav-item user_info_dropdown" *ngIf="loggedIn">
              <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <div class="sidebar__user-img">
                  <span>
                    {{ profileDetails.firstName | slice : 0 : 1 | uppercase
                    }}{{
                    profileDetails.lastName | slice : 0 : 1 | uppercase
                    }}</span>
                </div>

                <div class="sidebar__user-title">
                  <p>
                    {{ profileDetails.firstName }} {{ profileDetails.lastName }}
                  </p>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/market-home" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Market</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/fee-home" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Fee</a>
            </li>
            <li class="nav-item" *ngIf="loggedIn">
              <a class="nav-link" routerLink="/commission-transaction" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Earn</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" routerLink="/spot" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Spot</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" routerLink="/eoptions-trade" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Options</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" routerLink="/launchpad" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Launchpad</a>
            </li>
            <li class="nav-item" (click)="showDropdown()" (mouseleave)="hideDropdown()">
              <a class="nav-link" routerLinkActive="active">Earn</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/blog" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Blog</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/dcabot" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">DCA</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/subscriptionpage" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Subscription</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [href]="siteSetting.externalSiteUrl" target="_blank">{{ siteSetting.externalSiteName
                }}</a>
            </li>
            <li class="nav-item" *ngIf="loggedIn">
              <a class="nav-link" routerLink="/dashboard" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Dashboard</a>
            </li>
            <li class="nav-item" *ngIf="loggedIn">
              <a class="nav-link" routerLink="/edit-profile" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Edit Profile</a>
            </li>
            <li class="nav-item" *ngIf="loggedIn">
              <a class="nav-link" routerLink="/wallet" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Wallet</a>
            </li>
            <li class="nav-item" *ngIf="loggedIn">
              <a class="nav-link" routerLink="/security" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Security</a>
            </li>
            <li class="nav-item" *ngIf="loggedIn">
              <a class="nav-link" href="javascript:void(0)" routerLinkActive="active" (click)="signOut()"
                [routerLinkActiveOptions]="{ exact: true }">Logout</a>
            </li>
          </ul>
          <ul class="navbar-nav justify-content-end flex-grow-1 align-item-center">
            <li class="nav-item" *ngIf="!loggedIn">
              <a class="nav-link" routerLink="/signin" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Sign In</a>
            </li>
            <li class="nav-item" *ngIf="!loggedIn">
              <a class="nav-link primary_btn" routerLink="/signup" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Sign Up</a>
            </li>
            <li class="nav-item dropdown user_info_dropdown mobile_none" *ngIf="loggedIn">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <div class="sidebar__user-img">
                  <span>
                    {{ profileDetails.firstName | slice : 0 : 1 | uppercase
                    }}{{
                    profileDetails.lastName | slice : 0 : 1 | uppercase
                    }}</span>
                </div>

                <div class="sidebar__user-title">
                  <p>
                    {{ profileDetails.firstName }} {{ profileDetails.lastName }}
                  </p>
                </div>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" routerLink="/edit-profile"><i class="bi bi-pencil-square me-1"></i> Edit
                    Profile</a>
                </li>
                <li>
                  <a class="dropdown-item" routerLink="/wallet"><i class="bi bi-wallet2 me-1"></i>Wallet</a>
                </li>
                <li>
                  <a class="dropdown-item" routerLink="/security"><i class="bi bi-shield-check me-1"></i>Security</a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a class="dropdown-item" href="javascript:void(0)" (click)="signOut()"><i
                      class="bi bi-door-closed me-1"></i>Logout</a>
                </li>
              </ul>
            </li>
            <li class="mobile_none">
              <app-theme></app-theme>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>

  <div class="disclaimer-container">
    <div class="disclaimer-text">
      {{notifications}}
    </div>
  </div>

  <!-- <div class="header__content">
    
    <a href="/" class="header__logo">
      <img src="assets/images/logo.svg" alt="" />
    </a>
    

    
    <button class="header__btn" type="button">
      <span></span>
      <span></span>
      <span></span>
    </button>

    
  </div> -->
</header>
<!-- end header -->
<div class="modal fade primary_modal" id="new_bot_modal" tabindex="-1" aria-labelledby="new_bot_modalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="new_bot_modalLabel">Start new bot</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="new_bot_panel">
          <a href="/dcabot">
            <div class="new_bot_panel_content">
              <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium qKdO78InOm9rrEHhxNsG css-vubbuv" focusable="false"
                aria-hidden="true" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="36" rx="10" fill="#28BA74"></rect>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M24 28.8c-.66 0-1.2-.54-1.2-1.2V8.4c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v19.2c0 .66-.54 1.2-1.2 1.2Zm-13.2-1.2v-4.8c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v4.8c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2Zm6-12v12c0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2v-12c0-.66-.54-1.2-1.2-1.2-.66 0-1.2.54-1.2 1.2Z"
                  fill="#fff"></path>
              </svg>
              <h4>DCA Bot</h4>
            </div>
            <p>
              The Dollar-cost Averaging bot multiplies your gains and reduces
              risks in volatile markets.
            </p>
          </a>
          <a href="/gridbot">
            <div class="new_bot_panel_content">
              <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium qKdO78InOm9rrEHhxNsG css-vubbuv" focusable="false"
                aria-hidden="true" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="36" rx="10" fill="#6552EC"></rect>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M27.6 8.1H8.4c-.66 0-1.2.54-1.2 1.2v2.4c0 .66.54 1.2 1.2 1.2h19.2c.66 0 1.2-.54 1.2-1.2V9.3c0-.66-.54-1.2-1.2-1.2ZM8.4 15.3h19.2c.66 0 1.2.54 1.2 1.2v1.2c0 .66-.54 1.2-1.2 1.2H8.4c-.66 0-1.2-.54-1.2-1.2v-1.2c0-.66.54-1.2 1.2-1.2Zm0 6h19.2c.66 0 1.2.54 1.2 1.2 0 .66-.54 1.2-1.2 1.2H8.4c-.66 0-1.2-.54-1.2-1.2 0-.66.54-1.2 1.2-1.2Zm-.6 4.8h20.4c.336 0 .6.264.6.6 0 .336-.264.6-.6.6H7.8a.594.594 0 0 1-.6-.6c0-.336.264-.6.6-.6Z"
                  fill="#fff"></path>
              </svg>
              <h4>GRID Bot</h4>
            </div>
            <p>
              The proven grid strategy bot maximizes your returns on the
              slightest price changes.
            </p>
          </a>




          <!-- <div style="font-family: 'Segoe UI', sans-serif; color: #fff; max-width: 600px; margin: 0 auto;">

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;"> -->

          <!-- <a href="/adminBot"
                style="text-decoration: none; background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; border: 1px solid rgba(40, 186, 116, 0.3); border-left: 4px solid #28BA74; display: flex; flex-direction: column; justify-content: center;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <svg style="width: 20px; height: 20px; color: #28BA74;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                    <polyline points="17 6 23 6 23 12"></polyline>
                  </svg>
                  <span style="margin-left: 8px; font-weight: 600; font-size: 14px; color: #fff;">VWAP Upside</span>
                </div>
                <p style="margin: 0; font-size: 11px; color: #aaa;">Standard volume trend.</p>
              </a> -->

          <!-- <a href="/adminTradeBotGuru"
                style="text-decoration: none; background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; border: 1px solid rgba(171, 71, 188, 0.3); border-left: 4px solid #AB47BC; display: flex; flex-direction: column; justify-content: center;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <svg style="width: 20px; height: 20px; color: #AB47BC;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <polygon
                      points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                    </polygon>
                  </svg>
                  <span style="margin-left: 8px; font-weight: 600; font-size: 14px; color: #fff;">Guru Bot</span>
                </div>
                <p style="margin: 0; font-size: 11px; color: #aaa;">Expert logic system.</p>
              </a> -->

          <!-- <a href="/adminTradeUpsideHanuman"
                style="text-decoration: none; background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; border: 1px solid rgba(40, 186, 116, 0.3); border-left: 4px solid #28BA74; display: flex; flex-direction: column; justify-content: center;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <svg style="width: 20px; height: 20px; color: #28BA74;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <path d="M12 19V5M5 12l7-7 7 7" />
                  </svg>
                  <span style="margin-left: 8px; font-weight: 600; font-size: 14px; color: #fff;">Hanuman Up</span>
                </div>
                <p style="margin: 0; font-size: 11px; color: #aaa;">Aggressive buying.</p>
              </a> -->

          <!-- <a href="/hanumanBot"
                style="text-decoration: none; background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; border: 1px solid rgba(239, 83, 80, 0.3); border-left: 4px solid #EF5350; display: flex; flex-direction: column; justify-content: center;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <svg style="width: 20px; height: 20px; color: #EF5350;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <path d="M12 5v14M19 12l-7 7-7-7" />
                  </svg>
                  <span style="margin-left: 8px; font-weight: 600; font-size: 14px; color: #fff;">Hanuman</span>
                </div>
                <p style="margin: 0; font-size: 11px; color: #aaa;">Short selling strategy.</p>
              </a>

            </div>
          </div> -->


        </div>
      </div>
    </div>
  </div>
</div>


<div class="drop-when-ever-up-menu" (mouseleave)="hideDropdown1()" *ngIf="dropdownVisible">
  <div class="row">


    <div class="col-xl-6" routerLink="/campaign">
      <a class="vric1 hrfef" href="/campaign">
        <div class="vric1in1">
          <img alt="cryptocurrency exchange"
            class="lithe animate__tada animate__animated animate__infinite animate__slow"
            src="/assets/images/campaign.png">
        </div>
        <div class="div-over-hed">
          <p class="hed_tag">Offers</p>
          <p class="hed_tagppp">Join &amp; win with our latest Offer</p>
        </div>
      </a>
    </div>
    <div class="col-xl-6" routerLink="/trading-contest">
      <a class="vric1 hrfef" href="/trading-contest">
        <div class="vric1in1">
          <img alt="cryptocurrency exchange"
            class="lithe animate__tada animate__animated animate__infinite animate__slow" src="/assets/images/cup.png">
        </div>
        <div class="div-over-hed">
          <p class="hed_tag">Trade Contest</p>
          <p class="hed_tagppp">Discover the latest trade contest details</p>
        </div>
      </a>
    </div>

    <div class="col-xl-6" routerLink="/task-center">
      <a class="vric1 hrfef">
        <div class="vric1in1">
          <img alt="cryptocurrency exchange"
            class="lithe animate__tada animate__animated animate__infinite animate__slow"
            src="/assets/images/secretary.png">
        </div>
        <div class="div-over-hed">
          <p class="h ed_tag">Task Center</p>
          <p class="hed_tagppp">Complete tasks, earn rewards</p>
        </div>
      </a>
    </div>

    <div class="col-xl-6" routerLink="/comming-soon">
      <a class="vric1 hrfef">
        <div class="vric1in1">
          <img alt="cryptocurrency exchange"
            class="lithe animate__tada animate__animated animate__infinite animate__slow"
            src="/assets/images/giftbox.png">
        </div>
        <div class="div-over-hed">
          <p class="hed_tag">Mystery</p>
          <p class="hed_tagppp">Finish tasks and unlock mystery boxes</p>
        </div>
      </a>
    </div>


    <div class="col-xl-6" routerLink="/comming-soon">
      <a class="vric1 hrfef">
        <div class="vric1in1">
          <img alt="cryptocurrency exchange"
            class="lithe animate__tada animate__animated animate__infinite animate__slow" src="/assets/images/vote.png">
        </div>
        <div class="div-over-hed">
          <p class="hed_tag">Voting</p>
          <p class="hed_tagppp">Vote for your favourite crypto</p>
        </div>
        <p class="badge bg-danger text-white ps_live">Live</p>
      </a>
    </div>
  </div>
</div>

<div class="drop-when-ever-up-menu" (mouseleave)="hideDropdown1blog()" *ngIf="dropdownVisibleblog">
  <div class="column">

    <!-- Blog -->
    <div class="col-xl-6" routerLink="/blog">
      <a class="vric1 hrfef" href="/blog">
        <div class="vric1in1">
          <i class="fas fa-newspaper fa-2x animate__animated animate__fadeInUp animate__slower"
            style="color: #28a745;"></i>
        </div>
        <div class="div-over-hed">
          <p class="hed_tag">Blog</p>
        </div>
      </a>
    </div>

    <!-- Tutorials -->
    <div class="col-xl-6" routerLink="/learn">
      <a class="vric1 hrfef" href="/learn">
        <div class="vric1in1">
          <i class="fas fa-book-open fa-2x animate__animated animate__fadeInUp animate__slower"
            style="color: #ffc107;"></i>
        </div>
        <div class="div-over-hed">
          <p class="hed_tag">Tutorials</p>
        </div>
      </a>
    </div>

    <!-- Events -->
    <div class="col-xl-6" routerLink="/events">
      <a class="vric1 hrfef">
        <div class="vric1in1">
          <i class="fas fa-calendar-day fa-2x animate__animated animate__fadeInUp animate__slower"
            style="color: #dc3545;"></i>
        </div>
        <div class="div-over-hed">
          <p class="hed_tag">Events</p>
        </div>
      </a>
    </div>

    <!-- Videos -->
    <div class="col-xl-6">
      <a class="vric1 hrfef" href="https://www.youtube.com/@Credbull_Exchange" target="_blank"
        rel="noopener noreferrer">
        <div class="vric1in1">
          <i class="fas fa-video fa-2x animate__animated animate__fadeInUp animate__slower" style="color: #007bff;"></i>
        </div>
        <div class="div-over-hed">
          <p class="hed_tag">Videos</p>
        </div>
      </a>
    </div>

  </div>
</div>